import { connect } from 'react-redux';

import { changeBasketQuantity } from 'apps/basket/actions/basket';

import MiniTrolleyItem from 'apps/header/components/MiniTrolleyItem';

export default connect(
  (state, ownProps) => ({
    analyticsContextBasketItems: state.basket.items,
    basketItem: state.basket.items.find(item => item.sku === ownProps.sku),
    betaFeatures: state.user.betaFeatures,
    productWarnings: state.basket.productWarnings[ownProps.sku],
    product: state.products.productsBySku[ownProps.sku],
  }),
  {
    changeBasketQuantity,
  }
)(MiniTrolleyItem);
